var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAppWhiteSymbolBlack(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 114,
    height: 114,
    viewBox: "0 0 114 114",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_58323_294842)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 10,
    width: 85,
    height: 94,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.79 59.26C62.1 59.26 64.12 54.58 64.12 48.89V40.24C64.12 34.55 62.11 29.86 56.79 29.86C51.47 29.86 49.45 34.56 49.45 40.24V48.89C49.45 54.57 51.48 59.26 56.79 59.26Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.56 0H12C5.4 0 0 5.4 0 12V101.56C0 108.16 5.4 113.56 12 113.56H101.56C108.16 113.56 113.56 108.16 113.56 101.56V12C113.56 5.4 108.16 0 101.56 0ZM56.79 17.12C72.25 17.12 84.78 29.65 84.78 45.11C84.78 60.57 72.25 73.1 56.79 73.1C41.33 73.1 28.8 60.57 28.8 45.11C28.8 29.65 41.33 17.12 56.79 17.12ZM28.43 94.45C35.43 78.79 53.8 71.77 69.46 78.78C76.44 81.9 82.02 87.48 85.13 94.45H28.43Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_58323_294842"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 113.56,
    height: 113.56,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppWhiteSymbolBlack);
export default __webpack_public_path__ + "static/media/app_white_symbol_black.b31a1301735072f2b3c588134b475a44.svg";
export { ForwardRef as ReactComponent };